import React, { forwardRef } from "react";
import Marquee from "react-fast-marquee";
import { ReactComponent as GoldenArrow } from "../../assets/images/svg/arrowDownGolden.svg";

const DropdownButton = forwardRef(
  (
    {
      heading,
      dropDownContainerClass,
      isTextOverflowing,
      disabledPopup,
      reportsMenuOpen,
    },
    ref,
  ) => {
    return (
      <div className={`${dropDownContainerClass || ""} dropdown_btn`}>
        {isTextOverflowing ? (
          <Marquee speed={24} pauseOnHover gradient={false}>
            <p className="selected_text marquee-text">{heading}</p>
          </Marquee>
        ) : (
          <p
            className="selected_text"
            ref={ref}
            style={{
              width: "calc(100% - 23px)",
              overflowX: "hidden",
            }}
          >
            {heading}
          </p>
        )}
        {!disabledPopup ? (
          <div
            className={`golden_down_arrow ${reportsMenuOpen ? "is-active" : ""}`}
          >
            <GoldenArrow />
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  },
);

export default DropdownButton;
